import React, { forwardRef } from "react";
import { Dropdown, Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { SMU_SELECTED_MENU } from "../../constants";

const SmuProfile = ({ avatar, name, _className, menu, isAdmin }) => {
  const navigate = useNavigate();

  const Toggle = forwardRef(({ children, onClick }, ref) => {
    return (
      <div
        className="profile d-flex justify-content-end ms-4"
        ref={ref}
        onClick={onClick}
      >
        {children}
      </div>
    );
  });

  return (
    <Dropdown align="end" className={`profile-dropdown ${_className || ""}`}>
      <Dropdown.Toggle as={Toggle}>
        <div className="profile__name text-truncate smu-text-ligth fs-6">{name}</div>
        <Image src={avatar} roundedCircle width={48} height={48} />
      </Dropdown.Toggle>

      {isAdmin && (
        <Dropdown.Menu className="border-0 shadow">
          {menu.map((item) => (
            <Dropdown.Item
              key={item.id}
              eventKey={item.id}
              onClick={() => {
                // Clear SMU_SELECTED_MENU when clicking "Ir al Admin"
                localStorage.removeItem(SMU_SELECTED_MENU);
                // If item has a custom onClick handler, call it first
                if (item.onClick) {
                  item.onClick();
                }
                // Then navigate to the path
                navigate(item.path);
              }}
            >
              {item.Icon} <span className="ms-3">{item.title}</span>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      )}
    </Dropdown>
  );
};

export default SmuProfile;
